module.exports = __webpack_public_path__ + "static/media/female.e5f56d1a.svg";